<template>
  <div class="sel" :class="{ active: active }">
    <div class="btn-wrap">
      <span
        @click="choosedCategory(item)"
        :title="item.categoryName"
        class="ellipsis cursor-pointer item_span"
        >{{ item.categoryName }}</span
      >
      <img src="~@/assets/img/premium/down.png" />
    </div>
    <div class="list">
      <span
        v-for="(v, i) in item.children"
        @click="choosedCategory(v)"
        :key="i"
      >
        {{ v.categoryName }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: false,
    },
    needBoutiqueCategoryId: {
      type: Boolean,
      default: () => false,
    },
    needForegroundCategoryId: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    choosedCategory(v) {
      this.$emit("choosedCategory", v, this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.sel {
  display: inline-block;
  // margin: 0 12px 0 0;
  width: 100%;
  font-size: 0;
  &.active {
    .btn-wrap {
      border-color: #2a54d1;
    }
  }
  &:hover {
    .btn-wrap {
      border-color: #2a54d1;
    }
    img {
      transform: rotate(180deg); /* 旋转180度 */
    }
  }
  .btn-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #cccccc;
    padding: 1px 4px 2px 8px;
    border-radius: 8px;
    max-width: 110px;
    img {
      cursor: pointer;
      transition: all 0.5s ease; /* 添加过渡效果 */
    }
  }
  .item_span {
    color: #333333;
    font-size: 14px;
    line-height: 25px;
    padding-right: 4px;
  }
  .list {
    position: absolute;
    left: 0;
    top: 27px;
    z-index: 999;
    width: 100%;
    padding: 12px;
    border: 1px solid #2a54d1;
    border-radius: 6px 12px 12px 12px;
    display: none;
    background: #fff;
    transition: all 0.5s ease; /* 添加过渡效果 */
    text-align: left;
    span {
      display: inline-block;
      color: #666666;
      font-size: 14px;
      line-height: 19px;
      margin-right: 12px;
      cursor: pointer;
      &:hover {
        color: #2a54d1;
      }
    }
  }
  &:hover {
    .list {
      display: block;
      transition: all 0.5s ease; /* 添加过渡效果 */
    }
  }
}
</style>
